<template>
  <div id="app" class="container container-main">
    <my-nav-bar v-if="hideforcopy" :login="login" :iss="issWorking" :show-copies="showCopies" :selected-semester="selectedSemester"
      :conflicts-count="conflictsCount"
      @select-semester="selectSemesterClick" v-model="remember" :login-error-message="loginErrorMessage"
      @show-copies-click="showCopiesClick" @iss-click="winLoaderShow" @logout="logout" @save-settings="saveSettings"
      @get-iss-works="getIssWorks" @add-self-lesson="() => { this.$bvModal.show('selfleswin') }"
      @conflicts-click="() => { this.$bvModal.show('conflictswin') }"
      @get-api-token="getApiToken"
      @clear-auth="clearAuth"
      @clear-lessons="clearLessons">
    </my-nav-bar>
    <rasp-loading-show :loading="loading" :message="winStud.message"></rasp-loading-show>
    <st-rasp-win :win-stud="winStud" :login="login"
      @get-st-rasp="({ group, date }) => { getStRasp(group, date) }"></st-rasp-win>
    <kab-win :win-kab="winKab" @set-day="day => { winKab.current.cDay = day }" @set-kab="kab => { winKab.current.kab = kab }"
      @set-corp="corp => { getKab(winKab.day, corp) }" @change-kab="changeKab" @change-kab-cancel="changeKabCancel"></kab-win>
    <log-win :win-log="winLog" @entry-deleted="clearIssFlags"></log-win>
    <load-dash-win :works="winSync.data" :days="days" :login="login" :password-a-e-s="passwordAES"
      :semester="selectedSemester" :busy="issWorking" @reload="getIssWorks"></load-dash-win>
    <!-- Аудит кафедры вынесен в отдельное приложение iss-audit-local
    <dept-audit-win :login="login" :password-a-e-s="passwordAES" :semester="selectedSemester" :messages="messages"></dept-audit-win>
    -->
    <self-les-win :days="days" :login="login" :password-a-e-s="passwordAES" @lesson-add="addSelfLesson" @lesson-add-multi="lessonAddMulti"
      @dept-imported="loadData"></self-les-win>
    <edit-les-win :win-edit-les="winEditLes" @lesson-edit-submit="editSelfLesson"></edit-les-win>
    <loader-win :messages="messages"></loader-win>
    <ws-feed v-if="hideforcopy && login" :messages="messages"></ws-feed>
    <lesson-info-win :lesson-info="lessonInfo"></lesson-info-win>
    <conflicts-win :login="login" :password-a-e-s="passwordAES" @count-changed="c => { conflictsCount = c }" @resolved="loadData"></conflicts-win>
    <iss-del-win :ctx="issDel" :messages="messages"></iss-del-win>
    <journal-win :login="login" :password-a-e-s="passwordAES" :ctx="journalCtx"
      @switch-group="g => { journalCtx = { ...journalCtx, group: g } }"></journal-win>
    <subject-settings-win :login="login" :password-a-e-s="passwordAES" :ctx="subjectCtx" @saved="loadData"></subject-settings-win>

    <lesson-copy-block :clipboard="clipboard" :copy-count="copyCount"
      @exit="raspSeartchMode = false; clipboard = {}; loadData()" v-if="raspSeartchMode"></lesson-copy-block>

    <div v-for="(day, idd) in filteredDays" :key="idd" v-show="!loading && dayHasMatches(day)">

      <day-name :id="idd" :hideforcopy="hideforcopy" :name="day.day" @btn-click="sendDayWork(idd)"></day-name>
      <div v-for="(lesson, idl) in day.lessons" :key="idl" class="lesson"
        :class="[
          (lesson.sync && lesson.sync.status == 'collision') ? 'lesson-collision' : '',
          (lesson.sync && lesson.sync.status == 'new') ? 'lesson-new' : '',
          ((lesson.stkab) ? 'besy' : ((lesson.predm == '') ? 'free' : ''))
        ]"
        v-show="(((lesson.predm != '' && (!lesson.copied || (lesson.copied && showCopies))) || raspSeartchMode) && lessonMatches(lesson))">

        <lesson-menu v-if="hideforcopy && !raspSeartchMode" :id="{ idd, idl }" :lesson="lesson" @close="closeMenus(lesson)"
          @kab-click="getKab(day.day, lesson.kab, lesson, idl); lesson.showmenu = false;"
          @strasp-click="getStRasp(lesson.groups[0], dateFormat(day.day)); lesson.showmenu = false;"
          @settings-click="openSubjectSettings(lesson); lesson.showmenu = false;"
          @grades-click="openJournal(lesson.groups[0], lesson, day.day); lesson.showmenu = false;"
          @work-click="sendOneWork(idd, idl); lesson.showmenu = false;"
          @copy-click="getStRaspAll(lesson, idd); lesson.showmenu = false; copyCount = 0;"
          @del-click="delLesson(lesson, day.day, idd, idl); lesson.showmenu = false;"
          @info-click="infoLesson(lesson); lesson.showmenu = false;"
          @edit-click="editLesson(lesson, day.day); lesson.showmenu = false;"></lesson-menu>

        <div class="lesson-row" :class="{ 'two-col': lesson.sync && lesson.sync.status == 'collision' }">
          <div class="lesson-col lesson-local">
            <div class="stkab">{{ (lesson.stkab[1] == 'a') ? 'Teams' : lesson.stkab }}</div>
            <div v-if="lesson.sync && lesson.sync.status == 'local_only'" class="local-only-mark"
              title="Добавлено вручную или локальная запись">👆<small> вручную</small></div>
            <lesson-name :lesson="lesson"></lesson-name>
            <lesson-content :lesson="lesson" :hide-copy-label="hideforcopy" @kab-click="getKab(day.day, lesson.kab, lesson, idl);"
              @set-win-log="() => openWinLog(lesson)" @iss-check-click="issCheckClick(lesson)"
              @groups-click="g => openJournal(g, lesson, day.day)"></lesson-content>
              <button v-for="gv in lesson.variants" :key="gv.i" type="button" class="btn btn-sm btn-warning variant-btn" @click="lesson.i = gv.i; sendOneWork(idd, idl);" :aria-pressed="(lesson.i == gv.i)">{{gv.groups}}</button>
            <div v-if="lesson.predm == '' && raspSeartchMode" class="variant-placeholder"></div>
          </div>
          <div v-if="lesson.sync && lesson.sync.status == 'collision' && lesson.sync.remote_lesson" class="lesson-col lesson-remote">
            <b-badge variant="danger" class="mb-1">⚠ Коллизия с ВятГУ</b-badge>
            <lesson-name :lesson="lesson.sync.remote_lesson"></lesson-name>
            <lesson-content :lesson="lesson.sync.remote_lesson" :hide-copy-label="hideforcopy"></lesson-content>
          </div>
        </div>
      </div>
      <hr v-if="hideforcopy">
    </div>

    <div class="kab-rasp-fixed" v-if="hideforcopy">
      <b-button v-if="!login" variant="outline-primary" @click="getKab(today(), prompt('Введите номер корпуса', '16'), null, Number(prompt('Введите номер занятия', '1')) - 1)">Расписание кабинетов</b-button>
    </div>

    <my-week-selector @change-week="changeWeek" v-show="!raspSeartchMode && hideforcopy" @copy="copy()"
      :search="searchQuery" :group="groupFilter" :type="typeFilter" :expanded="filtersExpanded"
      :groups="availableGroups" :types="availableTypes" :active-count="activeFilterCount"
      @update:search="v => searchQuery = v" @update:group="v => groupFilter = v" @update:type="v => typeFilter = v"
      @toggle-expanded="filtersExpanded = !filtersExpanded" @reset="resetFilters" />
  </div>
</template>

<script>

const PATH = process.env.VUE_APP_PATH;

import lessonName from './components/content/lessonName.vue'
import lessonContent from './components/content/lessonContent.vue'
import lessonMenu from './components/content/lessonMenu.vue'
import lessonCopyBlock from './components/content/lessonCopyBlock.vue'
import { lessonCopyMixin } from './mixins/lessonCopyMixin'
import { interfaceMixin } from './mixins/interfaceMixin'
import { issMixin } from './mixins/issMixin'
import { kabMixin } from './mixins/kabMixin'
import { stRaspMixin } from './mixins/stRaspMixin'
import dayName from './components/content/dayName.vue'
import myNavBar from './components/interface/myNavBar.vue'
import myWeekSelector from './components/interface/myWeekSelector.vue'
import raspLoadingShow from './components/interface/raspLoadingShow.vue'
import wsFeed from './components/interface/wsFeed.vue'
import stRaspWin from './components/windows/stRaspWin.vue'
import kabWin from './components/windows/kabWin.vue'
import logWin from './components/windows/logWin.vue'
import loadDashWin from './components/windows/loadDashWin.vue'
// import deptAuditWin from './components/windows/deptAuditWin.vue'  // аудит кафедры — отдельное приложение iss-audit-local
import issDelWin from './components/windows/issDelWin.vue'
import loaderWin from './components/windows/loaderWin.vue'
import selfLesWin from './components/windows/selfLesWin.vue'
import editLesWin from './components/windows/editLesWin.vue'
import lessonInfoWin from './components/windows/lessonInfoWin.vue'
import conflictsWin from './components/windows/conflictsWin.vue'
import journalWin from './components/windows/journalWin.vue'
import subjectSettingsWin from './components/windows/subjectSettingsWin.vue'
import { connect as wsConnect } from './ws'

export default {
  name: 'App',
  mixins: [
    lessonCopyMixin,
    interfaceMixin,
    issMixin,
    kabMixin,
    stRaspMixin,
  ],
  components: {
    lessonName,
    lessonContent,
    lessonMenu,
    lessonCopyBlock,
    dayName,
    myNavBar,
    myWeekSelector,
    raspLoadingShow,
    wsFeed,
    stRaspWin,
    kabWin,
    loadDashWin,
    // deptAuditWin,
    issDelWin,
    logWin,
    loaderWin,
    selfLesWin,
    editLesWin,
    lessonInfoWin,
    conflictsWin,
    journalWin,
    subjectSettingsWin,
  },
  computed: {
    filteredDays() {
      return this.days.filter(day => (this.weekFilter.start == 'NaN-aN-aN' || day.day >= this.weekFilter.start && day.day <= this.weekFilter.end))
    },
    availableGroups() {
      const set = new Set()
      this.days.forEach(day => (day.lessons || []).forEach(l => (l.groups || []).forEach(g => set.add(g))))
      return Array.from(set).sort()
    },
    availableTypes() {
      const set = new Set()
      this.days.forEach(day => (day.lessons || []).forEach(l => { if (l.type) set.add(l.type) }))
      return Array.from(set).sort()
    },
    activeFilterCount() {
      let n = 0
      if (this.searchQuery) n++
      if (this.groupFilter) n++
      if (this.typeFilter) n++
      return n
    }
  },
  data: () => {
    return {
      days: [],
      weekFilter: { start: 'NaN-aN-aN', end: 'NaN-aN-aN' },
      hideforcopy: true,
      conflictsCount: 0,
      searchQuery: '',
      groupFilter: '',
      typeFilter: '',
      filtersExpanded: false,
      journalCtx: { group: '', groups: [], predm: '', day: '', time: '' },
      subjectCtx: { predm: '', groups: [] },
      // удаление занятия, записанного в ISS (issDelWin)
      issDel: { label: '', opId: '', start: 0, running: false, result: null },
      winEditLes: {
        _id: null,
        origDay: '',
        origTime: '',
        day: '',
        lesson: { time: '', predm: '', type: 'Лекция', kab: '', groups: '' }
      }
    }
  },
  created() {
    // Соединение WebSocket-клиента (см. ./ws.js). Намеренно не в data() —
    // Vue2 не должен пытаться делать реактивным объект с открытым сокетом.
    this.wsConn = null
  },
  methods: {
    copy(){
      this.hideforcopy = false;
      setTimeout(()=>{
        document.execCommand('selectAll')
        document.execCommand('copy');
        window.getSelection().removeAllRanges();
        setTimeout(()=>{
          this.hideforcopy = true;
        },200);
      },200);
    },
    prompt (a, b) {
      return prompt(a, b)
    },
    Number (a) {
      return Number(a)
    },
    async loadData() {

      if (localStorage.remember == "true") {
        this.login = localStorage.login;
        this.passwordAES = localStorage.passwordAES;
        this.remember = true;
      }

      this.days = []
      if (!this.login) {
        document.querySelector('li[id="loginmenu"] a').click()
        return 0
      }

      var scrollToLesson = (id) => {
        setTimeout(() => {
          window.location.href = "#" + id;
        }, 300);
      }

      if (localStorage.dump) {
        var days = JSON.parse(localStorage.dump)
        var now = this.today()
        days.forEach((day, id) => {
          if (day.day == now) scrollToLesson(id)
        })
        this.days = days
      } else this.loading = true
      if (this.wsConn) this.wsConn.close()
      this.wsConn = wsConnect(this.login, this.passwordAES)
      this.wsConn.on('my-event', data => {
        this.messages.push(data);
        this.winStud.message = data.message
        var objDiv = document.getElementById("my-event");
        if (objDiv) objDiv.scrollTop = objDiv?.scrollHeight + 100;
      });

      this.axios.post(PATH + '/api/rasp', {
        login: this.login,
        passwordAES: this.passwordAES
      })
        .then(response => {
          this.loading = false

          var now = this.today()
          response.data.forEach((day, id) => {
            day.lessons.forEach(l => {
              l.i = undefined
              l.variants = undefined
              l.status = ''
              l.showmenu = false
              if (!('copied' in l)) l.copied = false
              l.unsaved = false
              l.stkab = ''
            })
            if (!localStorage.dump && day.day == now) scrollToLesson(id)
          })

          localStorage.dump = JSON.stringify(response.data)

          this.days = response.data

          this.refreshConflictsCount()

        })
        .catch(({ response }) => {
          this.loading = false
          this.logout()
          this.loginErrorMessage = response.data.error
        })
    },
    refreshConflictsCount() {
      if (!this.login) return
      this.axios.post(PATH + '/api/rasp/conflicts', {
        login: this.login,
        passwordAES: this.passwordAES
      }).then(response => {
        this.conflictsCount = (response.data.unresolved || []).length
      }).catch(() => {})
    },
    changeWeek(week) {
      this.weekFilter = week
      window.location.href = "#0"
    },
    lessonMatches(lesson) {
      if (this.raspSeartchMode) return true
      var q = (this.searchQuery || '').trim().toLowerCase()
      if (q && !(lesson.predm || '').toLowerCase().includes(q)) return false
      if (this.groupFilter && !(lesson.groups || []).includes(this.groupFilter)) return false
      if (this.typeFilter && lesson.type !== this.typeFilter) return false
      return true
    },
    dayHasMatches(day) {
      if (this.raspSeartchMode || this.activeFilterCount === 0) return true
      return (day.lessons || []).some(l => this.lessonMatches(l))
    },
    resetFilters() {
      this.searchQuery = ''
      this.groupFilter = ''
      this.typeFilter = ''
    },
    issCheckClick(lesson) {
      this.axios.post(PATH + '/api/iss/del-iss-label-for-lesson', { _id: lesson._id })
        .then(()=>{
          lesson.in_iss = 0
        })
    },
    openJournal(group, lesson, day) {
      this.journalCtx = { group, groups: [...(lesson.groups || [])], predm: lesson.predm, day, time: lesson.time }
      // событие show модалки синхронное: без nextTick journalWin получил бы
      // ещё старый ctx (пустую группу) и не загрузил журнал
      this.$nextTick(() => this.$bvModal.show('journalwin'))
    },
    // настройки предмета: предмет + набор групп занятия (не одно занятие)
    openSubjectSettings(lesson) {
      this.subjectCtx = { predm: lesson.predm, groups: [...(lesson.groups || [])] }
      this.$nextTick(() => this.$bvModal.show('subjectsettingswin'))
    },
    editLesson(lesson, day) {
      this.winEditLes._id = lesson._id
      this.winEditLes.origDay = day
      this.winEditLes.origTime = lesson.time
      this.winEditLes.day = day
      this.winEditLes.lesson = {
        time: lesson.time,
        predm: lesson.predm,
        type: lesson.type,
        kab: lesson.kab,
        groups: (lesson.groups && lesson.groups[0]) || ''
      }
      this.$bvModal.show('editleswin')
    },
    clearAuth() {
      this.$bvModal.msgBoxConfirm(
        'Удалить из базы данных все авторизации (сессии) этого пользователя? Текущая сессия также будет завершена — потребуется войти заново.',
        { title: 'Очистить авторизации', okTitle: 'Удалить', cancelTitle: 'Отмена', okVariant: 'danger', centered: true, size: 'sm' }
      ).then(ok => {
        if (!ok) return
        this.axios.post(PATH + '/api/cleanup/auth', { login: this.login, passwordAES: this.passwordAES })
          .then(() => {
            localStorage.removeItem('dump')
            this.logout()
          })
          .catch(() => { this.loginErrorMessage = 'Не удалось очистить авторизации' })
      }).catch(() => {})
    },
    clearLessons() {
      this.$bvModal.msgBoxConfirm(
        'Удалить из базы данных все занятия этого пользователя? Данные будут выгружены заново при следующей загрузке расписания.',
        { title: 'Очистить занятия', okTitle: 'Удалить', cancelTitle: 'Отмена', okVariant: 'danger', centered: true, size: 'sm' }
      ).then(ok => {
        if (!ok) return
        this.axios.post(PATH + '/api/cleanup/lessons', { login: this.login, passwordAES: this.passwordAES })
          .then(() => {
            localStorage.removeItem('dump')
            this.loadData()
          })
          .catch(() => { this.loginErrorMessage = 'Не удалось очистить занятия' })
      }).catch(() => {})
    }
  },
  mounted() {
    this.loadData()
    window.dump = {}
  }
}
</script>

<style>
/* Токены дизайн-системы: Flat Design, teal + акцент оранжевый.
   Светлая тема по умолчанию, тёмная — по prefers-color-scheme (тема устройства). */
:root {
  color-scheme: light dark;
  --color-busy: #d9534f;
  --color-busy-bg: rgba(237, 20, 61, 0.14);
  --color-free: #2f9e63;
  --color-free-bg: rgba(34, 197, 94, 0.16);
  --color-current: #b8860b;
  --color-current-bg: #fdf5d0;
  --border-muted: #d9e6e2;
  --progress-track: rgba(148, 178, 170, 0.35);
  --table-highlight: #e0f2f1;
  --navbar-bg: rgba(240, 253, 250, 0.82);

  --bg: #f0fdfa;
  --bg-elevated: #ffffff;
  --bg-muted: #e8f1f4;
  --text: #134e4a;
  --text-muted: #5b7470;
  --border: #d5e8e3;
  --primary: #0d9488;
  --primary-hover: #0f766e;
  --on-primary: #ffffff;
  --accent: #ea580c;
  --danger: #dc2626;
  --success: #16a34a;
  --warning: #bf6a02;
  --on-warning: #ffffff;
  --shadow: rgba(15, 78, 74, 0.12);
  --menu-bg: #ffffff;
  --menu-border: #d5e8e3;
  --scrim: rgba(19, 78, 74, 0.28);
  --item-hover: #e9f5f2;
  --overlay-bg: rgba(248, 249, 250, 0.88);
}

@media (prefers-color-scheme: dark) {
  :root {
    --color-busy: #f87171;
    --color-busy-bg: rgba(248, 113, 113, 0.16);
    --color-free: #4ade80;
    --color-free-bg: rgba(74, 222, 128, 0.16);
    --color-current: #fbbf24;
    --color-current-bg: rgba(251, 191, 36, 0.18);
    --border-muted: #27423e;
    --progress-track: rgba(148, 178, 170, 0.28);
    --table-highlight: #17302b;
    --navbar-bg: rgba(11, 23, 21, 0.82);

    --bg: #0b1715;
    --bg-elevated: #12241f;
    --bg-muted: #17302b;
    --text: #e6f4f1;
    --text-muted: #93b3ad;
    --border: #27423e;
    --primary: #2dd4bf;
    --primary-hover: #5eead4;
    --on-primary: #04302b;
    --accent: #fb923c;
    --danger: #f87171;
    --success: #4ade80;
    --warning: #fbbf24;
    --on-warning: #1c1300;
    --shadow: rgba(0, 0, 0, 0.45);
    --menu-bg: #12241f;
    --menu-border: #27423e;
    --scrim: rgba(0, 0, 0, 0.5);
    --item-hover: #1b322d;
    --overlay-bg: rgba(11, 23, 21, 0.9);
  }
}

html, body {
  background-color: var(--bg);
  color: var(--text);
}

/* Открыто модальное окно — расписание под ним не прокручивается.
   bootstrap-vue вешает на body класс .modal-open и рассчитывает на правило
   из Bootstrap 4, а в Bootstrap 5 проекта его нет: колесо/свайп над окном
   (например, над журналом) листали страницу под ним. */
body.modal-open {
  overflow: hidden !important;
}
/* докрутив до края таблицы/окна, прокрутка не передаётся странице */
.modal,
.modal-body {
  overscroll-behavior: contain;
}

#app {
  background-color: var(--bg);
  color: var(--text);
}

/* BootstrapVue-оверрайды под токены */
.text-muted { color: var(--text-muted) !important; }
a { color: var(--primary); }
b-textarea, textarea.form-control {
  background-color: var(--bg-elevated) !important;
  color: var(--text) !important;
  border-color: var(--border) !important;
}
.form-control, .custom-select, input[type="week"], input[type="search"] {
  background-color: var(--bg-elevated) !important;
  color: var(--text) !important;
  border-color: var(--border) !important;
}
/* bootstrap-vue рендерит <select class="custom-select"> (класс Bootstrap 4),
   но в проекте установлен Bootstrap 5 — там .custom-select переименован в
   .form-select и не определён вовсе. Без этого блока у .custom-select нет
   ни рамки, ни отступов, ни высоты — только цвета из правила выше. */
.custom-select,
.form-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  vertical-align: middle;
  border: 1px solid var(--border) !important;
  border-radius: 0.25rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
/* Шеврон у .custom-select (bootstrap-vue) — нейтральный серый, видим в обеих темах */
.custom-select,
.form-select {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='5' viewBox='0 0 8 5'%3E%3Cpath fill='%238c9b96' d='M0 0l4 5 4-5z'/%3E%3C/svg%3E") !important;
  background-repeat: no-repeat !important;
  background-position: right .75rem center !important;
  background-size: 8px 5px !important;
}
.custom-select-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
}
.custom-select option,
.form-select option {
  background-color: var(--bg-elevated);
  color: var(--text);
}
.form-control::placeholder { color: var(--text-muted) !important; }
.btn-light, .btn-outline-secondary, .btn-link {
  background-color: var(--bg-muted) !important;
  color: var(--text) !important;
  border-color: var(--border) !important;
}
.btn-light:hover, .btn-outline-secondary:hover {
  background-color: var(--item-hover) !important;
}
.btn-primary {
  background-color: var(--primary) !important;
  border-color: var(--primary) !important;
  color: var(--on-primary) !important;
}
.btn-primary:hover {
  background-color: var(--primary-hover) !important;
  border-color: var(--primary-hover) !important;
}
/* .btn-outline-primary остаётся "призрачной" (прозрачный фон), пока не .active/
   [aria-pressed=true] — иначе кнопки-переключатели (например, выбор семестра
   "первый"/"второй") выглядят одинаково залитыми и не видно, какая выбрана. */
.btn-outline-primary {
  background-color: transparent !important;
  border-color: var(--primary) !important;
  color: var(--primary) !important;
}
.btn-outline-primary:hover {
  background-color: var(--item-hover) !important;
  border-color: var(--primary-hover) !important;
  color: var(--primary-hover) !important;
}
.btn-outline-primary.active,
.btn-outline-primary[aria-pressed="true"] {
  background-color: var(--primary) !important;
  border-color: var(--primary) !important;
  color: var(--on-primary) !important;
}
.btn-outline-primary.active:hover,
.btn-outline-primary[aria-pressed="true"]:hover {
  background-color: var(--primary-hover) !important;
  border-color: var(--primary-hover) !important;
}
.btn-warning {
  background-color: var(--accent) !important;
  border-color: var(--accent) !important;
  color: #fff !important;
}
.badge-light, .badge-primary {
  background-color: var(--primary) !important;
  color: var(--on-primary) !important;
}
/* Тот же пробел BS4/BS5, что и у .custom-select: bootstrap-vue вешает
   badge-${variant} (например badge-warning) + badge-pill, но Bootstrap 5
   их не определяет (только .badge база, без цвета фона и без пилюли) —
   бейдж остаётся прозрачным и сливается с кнопкой под ним. */
.badge-warning {
  background-color: var(--warning) !important;
  color: var(--on-warning) !important;
}
.badge-pill {
  border-radius: 50rem;
}
.navbar, .b-navbar {
  background-color: var(--navbar-bg) !important;
}
.nav-link, .navbar-brand, .b-navbar-brand { color: var(--text) !important; }
.dropdown-menu {
  background-color: var(--bg-elevated) !important;
  border: 1px solid var(--border) !important;
}
.dropdown-item { color: var(--text) !important; }
.dropdown-item:hover, .dropdown-item:focus { background-color: var(--item-hover) !important; }
.modal-content {
  background-color: var(--bg-elevated) !important;
  color: var(--text) !important;
  border: 1px solid var(--border) !important;
}
.modal-header, .modal-footer { border-color: var(--border) !important; }
.card { background-color: var(--bg-elevated) !important; border-color: var(--border) !important; }
.card-header { background-color: var(--bg-muted) !important; border-color: var(--border) !important; }
.table, .b-table {
  background-color: var(--bg-elevated) !important;
  --bs-table-bg: transparent;
}
.table, .b-table th, .b-table td { color: var(--text) !important; }
.table-bordered, .table-striped > tbody > tr:nth-of-type(odd) > * {
  border-color: var(--border) !important;
  --bs-table-accent-bg: var(--bg-muted);
}
.b-progress { background-color: var(--progress-track) !important; }
.alert { color: var(--text) !important; }
.alert-warning { background-color: var(--color-current-bg) !important; border-color: var(--color-current) !important; }
.alert-danger {
  background-color: var(--color-busy-bg) !important;
  border-color: var(--color-busy) !important;
  color: var(--text) !important;
}
.alert-success {
  background-color: var(--color-free-bg) !important;
  border-color: var(--color-free) !important;
  color: var(--text) !important;
}
.b-form-checkbox .custom-control-label, .custom-control-label { color: var(--text) !important; }
/* Оверлей ожидания (kabWin/stRaspWin): дефолт b-overlay — полупрозрачный
   белый, из-за чего в тёмной теме текст/спиннер не читаются. */
.b-overlay-backdrop,
.b-overlay {
  background-color: var(--overlay-bg) !important;
}
.b-overlay-backdrop,
.b-overlay .text-center,
.b-overlay p {
  color: var(--text) !important;
}
.b-overlay .b-icon {
  color: var(--text);
}

.stkab {
  position: relative;
  width: fit-content;
  margin: 0 0 0 auto;
  height: 0;
  font-size: small;
  color: var(--danger);
  padding: 0px;
}

.variant-btn {
  margin-right: 5px;
  font-weight: normal;
}

.variant-btn[aria-pressed="true"] {
  font-weight: 600;
}

.dropdown-menu {
  max-height: 350px !important;
  overflow-y: auto !important;
}

.container {
  max-width: 700px !important;
}

.container-main {
  padding-top: 65px !important;
  padding-bottom: 30px !important;
  overflow-x: clip !important;
}

svg {
  width: 40px;
  height: 40px;
  cursor: pointer;
}

.close {
  float: right;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: var(--text);
  text-shadow: none;
  opacity: .5;
  background-color: transparent;
  border: 0;
  cursor: pointer;
  padding: 1rem;
  margin: -1rem -1rem -1rem auto;
  font-family: inherit;

}

.lesson {
  position: relative;
  padding-left: 12px;
  padding-right: 58px;
  padding-bottom: 12px;
  padding-top: 8px;
  margin-top: 8px;
  margin-bottom: 4px;
  clear: both;
  border-radius: 12px;
  border: 1px solid transparent;
  transition: border-color .2s ease, background-color .2s ease;
  min-height: 60px;
  background-color: var(--bg-elevated);
}

/* Сценарии после синхронизации с ВятГУ (см. lib/rasp.js#raspAndDbConcat) */
.lesson-row {
  display: block;
}
.lesson-row.two-col {
  display: flex;
  gap: 12px;
  align-items: stretch;
}
.lesson-row.two-col .lesson-col {
  flex: 1 1 0;
  min-width: 0;
}
.lesson-col {
  position: relative;
}
.lesson-remote {
  border-left: 1px solid var(--border);
  padding: 8px 10px;
  background: var(--bg-muted);
  border-radius: 8px;
}

/* коллизия — два занятия в один слот: красная рамка (обе темы) */
.lesson-collision {
  border: 2px solid var(--danger) !important;
}

/* занятие, появившееся с сайта (однократно): контрастная рамка в зависимости от темы */
.lesson-new {
  border: 2px solid var(--primary) !important;
  box-shadow: 0 0 0 3px var(--scrim);
}

/* локальная/ручная запись (отсутствует в ВятГУ) — пометка после названия */
.local-only-mark {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  color: var(--accent);
  font-size: 0.8em;
  cursor: help;
}

.besy {
  border: 2px solid var(--color-busy) !important;
  background-color: var(--color-busy-bg) !important;
}

.free {
  border: 2px solid var(--color-free) !important;
  background-color: var(--color-free-bg) !important;
}

.current {
  border: 2px solid rgb(119, 128, 0) !important;
  background-color: var(--color-current-bg) !important;

  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: var(--color-current-bg) !important;
  z-index: 100;
}

.lesson:hover {
  background-color: var(--bg-muted);
}

.variant-placeholder {
  width: fit-content;
  position: relative;
  margin: auto;
  height: 0;
  top: -11px;
}

.kab-rasp-fixed {
  position: fixed;
  bottom: 122px;
  right: 16px;
  z-index: 900;
}

@media (prefers-reduced-motion: reduce) {
  .lesson {
    transition: none;
  }
}
</style>
